import { DropdownItem } from "./types";

export const getSelectedFromOptions = <T extends string = string>(
  options: Pick<DropdownItem<T>, "value">[],
  selectedValue?: string | null
): DropdownItem<T> | undefined => {
  if (!selectedValue) return;
  return options.find((o) => o.value === selectedValue);
};
